module.exports = "<div class=\"app-body\">\n\t<h1>You don't have access to this part of the system, or are coming from an unauthorised IP Address. Please contact the system administrator.</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./Client/app/common/noAccess/noAccess.html
// module id = 516
// module chunks = 0